module.exports = __webpack_public_path__ + "img/high_five.ab2ba1ab.svg";